<template>
  <div class="login">
    <div class="container">
      <h1 class="display-1 primary--text my-3">Cadastro para acesso a Nota Fiscal Avulsa</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 lg4 xl3>
          <v-card hover class="ma-3">
            <v-card-title class="title">Cadastro Prestador de Serviço</v-card-title>
            <v-card-text>
              <p>Utilize esta opção se você é pessoa física ou jurídica prestadora de serviços estabelecida em outro município obrigado à emissão de NFSe-A.</p>
            </v-card-text>

            <v-card-actions>
              <v-btn block depressed color="primary" @click="cadastrarPrestador">
                <v-icon left>card_travel</v-icon>
                <span>Cadastro Prestador de Serviço</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 lg4 xl3>
          <v-card hover class="ma-3">
            <v-card-title class="title">Pessoa Física e Jurídica</v-card-title>
            <v-card-text>
              <p>Quem deve se cadastrar nesta opção:</p>
              <ol>
                <li>Pessoa Jurídica não prestadora de serviço</li>
                <li>Pessoa Física não prestadora de serviço</li>
              </ol>
            </v-card-text>

            <v-card-actions>
              <v-btn
                block
                depressed
                color="info"
                href="https://acessoiss.sjc.sp.gov.br/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?multiTenantId=4&mostraCampoMatricula=N&faces-redirect=true"
                target="_blank"
              >
                <v-icon left>account_circle</v-icon>
                <span>Cadastrar como PF/PJ</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    cadastrarPrestador() {
      let urlAtual = window.location.hostname;

      if (urlAtual !== "notajoseense.sjc.sp.gov.br") {
        window.location.replace(
          "https://homol-notajoseense.sjc.sp.gov.br/notafiscal/paginas/contribuintefora/contribuinteForaList.jsf"
        );
      } else {
        window.location.replace(
          "https://notajoseense.sjc.sp.gov.br/notafiscal/paginas/contribuintefora/contribuinteForaList.jsf"
        );
      }
    }
  }
};
</script>
